export interface Question {
  id: number;
  question: string;
  answer: string;
  difficulty: "easy" | "medium" | "hard";
  comment?: string;
}

export const sampleQuestions: Question[] = [
  {
    id: 1,
    question:
      "Physicist Brian Greene writes in his book about parallel universes that, as a child, he liked to stand between these two objects in his room. Name the objects.",
    answer: "Mirrors",
    difficulty: "easy",
    comment:
      "According to Greene, he enjoyed standing between two mirrors and imagining that other worlds opened up on both sides of him, reflected infinitely within each other.",
  },
  {
    id: 2,
    question:
      "Name the PHRASE.\nDick Francis writes that at horse races, no one says THAT THREE-WORD PHRASE to a jockey, because the likelihood of THAT actually happening is too high.",
    answer: "Break a leg",
    difficulty: "medium",
    comment:
      'Dick Francis, who was a jockey himself, notes that the common expression for wishing someone good luck — "break a leg" — isn\'t used in horse racing. Injuries, including broken legs and other body parts, are all too common in the sport, so the phrase is considered inappropriate in that context.',
  },
  {
    id: 3,
    question:
      "According to one joke, the definitive illustration of how to make a snow angel properly actually appeared over five hundred years ago, and it's been known by THIS name ever since.",
    answer: "Vitruvian Man",
    difficulty: "hard",
    comment:
      "The Vitruvian Man is Leonardo da Vinci's famous drawing of a man with outstretched arms and legs in two superimposed positions. A snow angel is made by lying on your back in the snow and moving your arms and legs outward — a pose that closely resembles the figure in da Vinci's sketch. Hence, the drawing humorously resembles an ancient \"manual\" for making a snow angel.",
  },
];

export const socialLinks = {
  strava: "https://www.strava.com/clubs/quizrun",
  facebook: "https://www.facebook.com/groups/quizrun",
  instagram: "https://www.instagram.com/quiz_run",
  telegram: "https://t.me/quiz_run",
};
